import { useEffect, useState } from "react";
import { API_REPORTING_MANAGERS } from "../../config/Endpoints.js";
import { getAuthToken } from "../../utils/Storage.js";
import { getApi } from "../utils/api.ts";
import type { SelectOption } from "../components/ui/index.ts";

type ReportingManagersResponse = {
  data: { userId: number; name: string; ccEmail?: string }[];
};

export function useReportingManagers() {
  const [options, setOptions] = useState<SelectOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    getApi<ReportingManagersResponse>(
      API_REPORTING_MANAGERS,
      getAuthToken("accessToken"),
      "json",
      controller.signal,
    )
      .then(({ data }) => {
        if (!controller.signal.aborted) {
          setOptions((data.data ?? []).map(({ userId, name }) => ({
            value: String(userId), label: name,
          })));
        }
      })
      .catch((error: unknown) => {
        if (!controller.signal.aborted) {
          setError(error instanceof Error ? error.message : "Failed to load reporting managers.");
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, []);

  return { options, loading, error };
}
